export const READY_TO_IMPORT = "ready-to-import";
export const VALIDATION_ERROR = "validation-error";
export const IMPORTING = "importing";
export const IMPORT_ERROR = "import-error";
export const IMPORT_SUCCESS = "import-success";
